export default __webpack_public_path__ + "static/media/home-game-bg.77d07a3e.png";